import React from 'react';
import {connect} from 'react-redux';
import { browserHistory } from 'react-router'
import { getJsonFromUrl, isAndroid, isIos } from '../../utils'
import {WKPgyCheck} from '../../components/wk'
import houseImg from '../../images/lecture/icon-house.png'


class LectureTopLiveroomBar extends React.Component {
    getName (liveroom) {
        if (liveroom.name.length > 12) {
            return liveroom.name.slice(0, 12) + '...'
        } else {
            return liveroom.name
        }
    }
    getLiveroomAction (role, isFromApp) {
        if (isFromApp) {
            return '前往APP'
        }
        if (role.is_manager || role.is_fans) {
            return '进入直播间'
        } else {
            return '关注直播间'
        }
    }
    onClickLiveroom (liveroom, role, isFromApp) {
        if (isFromApp) {
            return this.toApp()
        }
        if (role.is_manager || role.is_fans) {
            location.assign(`/liveroom/${liveroom.id}`)
        } else {
            if (this.props.subtype !== 'record') {
                this.props.dispatch({ type: 'MTA_CLICK', payload: 'lecture-top-liveroom-bar-click-to-follow' })
            }
            this.props.dispatch({
                type: 'SHOW_FOLLOW_LIVEROOM',
                payload: {
                    liveroom: liveroom
                }
            })
        }
    }
    onClickBar (e, liveroom, role, isFromApp) {
        if (isFromApp) {
            this.toApp()
            return
        }
        if (role.is_manager || role.is_fans) {
            location.assign(`/liveroom/${liveroom.id}`)
        }
    }
    toApp () {
        this.props.dispatch({ type: 'MTA_CLICK', payload: 'app-share-lecture-top-liveroom-bar-click-to-app' })
        location.assign('https://a.app.qq.com/o/simple.jsp?pkgname=com.lizhiweike')
    }
    onClickLiveroomName (liveroom, isFromApp) {
        if (isFromApp) {
            return this.toApp()
        }
        let search = location.search.indexOf('pgy') > -1 ? location.search : ''
        location.assign(`/liveroom/${liveroom.id}${search}`)
    }
    render() {
        const liveroom = this.props.type === 'lecture' ? this.props.lecture.liveroom : this.props.channel.liveroom
        const role = this.props.type === 'lecture' ? this.props.lecture.role : this.props.channel.role
        const isFromApp = getJsonFromUrl().share_platform === 'app'
        return (
            <div className='lecture-top-liveroom-bar' onClick={e => this.onClickBar(e, liveroom, role, isFromApp)}>
                <div className="bar-left" onClick={e => this.onClickLiveroomName(liveroom, isFromApp)}>
                    {
                        !isFromApp && (
                            <div className="icon">
                                <img src={houseImg} alt=""/>
                            </div>
                        )
                    }
                    <div className="name">{isFromApp ? '使用APP全程回顾，永久回听' : this.getName(liveroom)}</div>
                </div>
                <div className="bar-right" onClick={e => this.onClickLiveroom(liveroom, role, isFromApp)}>{this.getLiveroomAction(role, isFromApp)}</div>
            </div>
        );
    }
}

export default connect((state) => ({
    lecture: state.lecture,
    channel: state.channel,
}))(LectureTopLiveroomBar);


// WEBPACK FOOTER //
// ./src/components/lecture/LectureTopLiveroomBar.js